/* tslint:disable */
/* eslint-disable */
/**
 * POS API
 * Internal POS API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  GetBillingStatus200Response,
  GetReservationFeatures200Response,
} from '../models/index';
import {
    GetBillingStatus200ResponseFromJSON,
    GetBillingStatus200ResponseToJSON,
    GetReservationFeatures200ResponseFromJSON,
    GetReservationFeatures200ResponseToJSON,
} from '../models/index';

/**
 * 
 */
export class InternalBillingApi extends runtime.BaseAPI {

    /**
     */
    async getBillingStatusRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetBillingStatus200Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/internal-billing/status`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetBillingStatus200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async getBillingStatus(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetBillingStatus200Response> {
        const response = await this.getBillingStatusRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getReservationsFeaturesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetReservationFeatures200Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/internal-billing/reservations`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetReservationFeatures200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async getReservationsFeatures(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetReservationFeatures200Response> {
        const response = await this.getReservationsFeaturesRaw(initOverrides);
        return await response.value();
    }

}
